module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('delete-field')
      }
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Webhook Field")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "col": "4",
      "md": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Local Field",
      "items": _vm.localFields,
      "rules": [_vm.ruleRequired]
    },
    model: {
      value: (_vm.field.localField),
      callback: function($$v) {
        _vm.$set(_vm.field, "localField", $$v)
      },
      expression: "field.localField"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "4",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "remoteField",
      "label": "Remote Field Name",
      "rules": [_vm.ruleRequired]
    },
    model: {
      value: (_vm.field.remoteFieldName),
      callback: function($$v) {
        _vm.$set(_vm.field, "remoteFieldName", $$v)
      },
      expression: "field.remoteFieldName"
    }
  })], 1), _vm._v(" "), (_vm.customString) ? _c('v-col', {
    attrs: {
      "col": "4",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "remoteField",
      "label": "Custom String Value",
      "rules": [_vm.ruleRequired]
    },
    model: {
      value: (_vm.field.stringValue),
      callback: function($$v) {
        _vm.$set(_vm.field, "stringValue", $$v)
      },
      expression: "field.stringValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.filterable) ? _c('v-col', {
    attrs: {
      "col": "4",
      "md": "4"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "name": "invertFilters",
      "label": "Invert Filters"
    },
    model: {
      value: (_vm.field.invertFilters),
      callback: function($$v) {
        _vm.$set(_vm.field, "invertFilters", $$v)
      },
      expression: "field.invertFilters"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.filterable) ? _c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "col": "4",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "remoteField",
      "label": "Filter Prefix"
    },
    model: {
      value: (_vm.field.filterPrefix),
      callback: function($$v) {
        _vm.$set(_vm.field, "filterPrefix", $$v)
      },
      expression: "field.filterPrefix"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "4",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "remoteField",
      "label": "Filter Suffix"
    },
    model: {
      value: (_vm.field.filterSuffix),
      callback: function($$v) {
        _vm.$set(_vm.field, "filterSuffix", $$v)
      },
      expression: "field.filterSuffix"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "4",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "remoteField",
      "label": "Filter Regex"
    },
    model: {
      value: (_vm.field.filterRegex),
      callback: function($$v) {
        _vm.$set(_vm.field, "filterRegex", $$v)
      },
      expression: "field.filterRegex"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.field.filterValidValues), function(value, i) {
    return _c('v-col', {
      key: i,
      attrs: {
        "col": "4",
        "md": "4"
      }
    }, [_c('v-text-field', {
      attrs: {
        "name": "remoteField",
        "label": "Filter Valid Value",
        "append-outer-icon": "delete"
      },
      on: {
        "click:append-outer": function($event) {
          return _vm.removeValidValue(i)
        }
      },
      model: {
        value: (_vm.field.filterValidValues[i]),
        callback: function($$v) {
          _vm.$set(_vm.field.filterValidValues, i, $$v)
        },
        expression: "field.filterValidValues[i]"
      }
    })], 1)
  }), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "md": "12"
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addValidValue()
      }
    }
  }, [_vm._v("\n              Add Valid Value\n            ")])], 1)], 2) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bee01fce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebhookFieldEdit.vue
// module id = 416
// module chunks = 1